import { Component } from '@angular/core';

import { EntityType } from '../../../../../api/targeting/enum/entity.type.enum';
import { PortfolioCategory } from '../../../enums/portfolio-category.enum';
import { PortfolioRegion } from '../../../enums/portfolio-region.enum';
import { PortfolioService } from '../portfolio-service';

@Component({
    selector: 'agpr-portfolio-left-panel',
    templateUrl: './portfolio-left-panel.component.html',
    styleUrls: ['./portfolio-left-panel.component.scss'],
    standalone: false
})

export class PortfolioLeftPanelComponent {

    readonly entityTypes = EntityType;
    readonly portfolioCategories = PortfolioCategory;
    readonly portfolioRegions = PortfolioRegion;

    public constructor(
        public portfolioService: PortfolioService) {
    }

    parametersChanged() {
        this.portfolioService.goToResults();
    }
}
